export const VUE_APP_SSO_LINK = process.env.VUE_APP_SSO_LINK || 'https://auth-ibbil-dev.dafagate.com'
export const VUE_APP_WEBSITE_LINK = process.env.VUE_APP_WEBSITE_LINK || 'https://website-api-ibbil-dev.dafagate.com/api/v1'
export const VUE_APP_VETERINARY_LINK = process.env.VUE_APP_VETERINARY_LINK || 'https://api-veterinary-ibbil-dev.dafagate.com/api/v1'
export const VUE_APP_PROFILE_URL = process.env.VUE_APP_PROFILE_URL || ''
